import { Controller } from '@hotwired/stimulus';

// Mirrors an input into a preview block as it is typed, hiding the block while blank.
export default class extends Controller {
  static targets = ['input', 'output', 'preview'];

  connect() {
    this.update();
  }

  update() {
    const message = this.inputTarget.value;

    this.outputTarget.textContent = message;
    this.previewTarget.classList.toggle('hide', message.trim() === '');
  }
}
